"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainMachineSummary = mapToDomainMachineSummary;
function mapToDomainMachineSummary(dto) {
    return {
        id: dto.id,
        code: dto.code,
        name: dto.name,
        siteName: dto.siteName,
        advertisingEnabled: dto.advertisingEnabled ?? false,
    };
}
